import styled from '@emotion/styled';
import Button from 'antd/es/button';
import ShopeeVoucherForm from './ShopeeVoucherForm';
import LazadaVoucherForm from './LazadaVoucherForm';
import KwaiVoucherForm from './KwaiVoucherForm';

const Content = styled.div`
  height: calc(100% - 104px);
  overflow-y: auto;

  .ant-form-item-label:after {
    content: ':';
  }

  .ant-input-number {
    width: 100%;
  }
`;
const Footer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 -2px 8px 0 rgba(167, 178, 204, 0.1), inset 0 1px 0 0 rgba(240, 242, 245, 1);
  background-color: #fff;
`;

export interface VoucherFormBodyProps {
  conversation: Conversation.Conversation;
  form: any;
  status?: Conversation.Voucher.Status;
  submitVoucher: (formValues: any) => void | Promise<void>;
  submitLoading: boolean;
  confirmText: string;
  dynamicRules?: Record<string, any>;
  /** 是否禁用提交按钮（如详情查看态） */
  submitButtonDisabled?: boolean;
  /** 是否显示底部提交按钮 */
  showFooter?: boolean;
}

/** 优惠券表单内容 + 底部提交按钮，供 Drawer/Modal 复用 */
export const VoucherFormBody = (props: VoucherFormBodyProps) => {
  const {
    conversation,
    form,
    status,
    submitVoucher,
    submitLoading,
    confirmText,
    dynamicRules,
    showFooter = true,
    submitButtonDisabled = false,
  } = props;
  const { storeId, storeAlias, storeName, region, channel } = conversation;
  const storeDisplayName = storeAlias || storeName || '';

  return (
    <>
      <Content>
        {channel === 'SHOPEE' ? (
          <ShopeeVoucherForm
            form={form}
            status={status}
            storeName={storeDisplayName}
            storeId={storeId}
            region={region}
            onFinish={(values) => {
              submitVoucher(values);
            }}
          />
        ) : null}
        {channel === 'LAZADA' ? (
          <LazadaVoucherForm
            form={form}
            status={status}
            storeName={storeDisplayName}
            storeId={storeId}
            region={region}
            onFinish={(values) => {
              submitVoucher(values);
            }}
            dynamicRules={dynamicRules}
          />
        ) : null}
        {channel === 'KWAI' ? (
          <KwaiVoucherForm
            form={form}
            status={status}
            storeName={storeDisplayName}
            storeId={storeId}
            region={region}
            onFinish={(values) => {
              submitVoucher(values);
            }}
            dynamicRules={dynamicRules}
          />
        ) : null}
      </Content>
      {showFooter && (
        <Footer>
          <Button
            disabled={submitButtonDisabled}
            type="primary"
            loading={submitLoading}
            onClick={() => {
              form.submit();
            }}
          >
            {confirmText}
          </Button>
        </Footer>
      )}
    </>
  );
};
